<div
    *ngIf="
        materialAlias.materialType.materialType == 67 ||
        materialAlias.materialType.materialType == 58 ||
        materialAlias.materialTypeId == 67 ||
        materialAlias.materialTypeId == 58
    "
>
    <div class="modal-header">
        <a class="close-icon" href="javascript:void()" ngbAutofocus (click)="ngbActiveModal.close()">
            <i class="flaticon2-cross"></i>
        </a>

        <div class="row w-100">
            <div class="col-md-7">
                <h4 class="mt-8">
                    <span *ngIf="materialAlias.materialType.materialType == 67 || materialAlias.materialTypeId == 67">{{
                        'SETTING_PAGE.IDMS_SETTINGS.SELECT_FLANGE_MATERIAL' | transloco
                    }}</span>
                    <span *ngIf="materialAlias.materialType.materialType == 58 || materialAlias.materialTypeId == 58">{{
                        'SETTING_PAGE.IDMS_SETTINGS.SELECT_BOLT_MATERIAL' | transloco
                    }}</span>
                </h4>
            </div>
            <div class="col-md-5 search-wrapper">
                <mat-form-field class="w-100 mt-0">
                    <!-- <mat-label #tooltip="matTooltip" matTooltip="Filter">
                        <mat-icon>search</mat-icon>
                    </mat-label>
                    <input matInput (keyup)="applyFilter($event)" #input /> -->
                    <input
                        matInput
                        (keyup)="applyFilter($event)"
                        [formControl]="searchText"
                        placeholder="{{ 'INFORMATE_POPUP.LABELS.SEARCH' | transloco }}"
                        #input
                    />
                    <button mat-button matPrefix mat-icon-button class="search_btn">
                        <mat-icon>search</mat-icon>
                    </button>
                </mat-form-field>
            </div>
        </div>
    </div>

    <div class="modal-body scroll-table informate-table-selection">
        <table mat-table [dataSource]="dataSourceMaterial" class="w-100">
            <ng-container matColumnDef="id" hidden="hidden">
                <th mat-header-cell *matHeaderCellDef style="display: none"></th>
                <td mat-cell *matCellDef="let element" style="display: none">{{ element.flangeMaterialId }}</td>
            </ng-container>

            <ng-container matColumnDef="position">
                <th mat-header-cell *matHeaderCellDef>{{ 'SETTING_PAGE.IDMS_SETTINGS.SPEC_NO' | transloco }}</th>
                <td mat-cell *matCellDef="let element">
                    <span *ngIf="materialAlias.materialType.materialType == 67 || materialAlias.materialTypeId == 67">
                        {{ element.flangeMaterialSpecNo.specNo }}
                    </span>
                    <span *ngIf="materialAlias.materialType.materialType == 58 || materialAlias.materialTypeId == 58">
                        {{ element.boltMaterialSpecNo.specNo }}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>{{ 'SETTING_PAGE.IDMS_SETTINGS.TYPE_GRADE' | transloco }}</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.typeGrade }}
                </td>
            </ng-container>

            <ng-container matColumnDef="design">
                <th mat-header-cell *matHeaderCellDef>{{ 'SETTING_PAGE.IDMS_SETTINGS.ALLOW_DESIGN' | transloco }}</th>
                <td mat-cell *matCellDef="let element">{{ element.alloyDesignUnsno }}</td>
            </ng-container>

            <ng-container matColumnDef="composition">
                <th mat-header-cell *matHeaderCellDef>{{ 'SETTING_PAGE.IDMS_SETTINGS.NOMINAL_COMPOSITION' | transloco }}</th>
                <td mat-cell *matCellDef="let element">{{ element.nominalComposition }}</td>
            </ng-container>

            <ng-container matColumnDef="class">
                <th mat-header-cell *matHeaderCellDef>{{ 'SETTING_PAGE.IDMS_SETTINGS.CLASS_CONDITION_TEMPERAMENT' | transloco }}</th>
                <td mat-cell *matCellDef="let element">{{ element.classCondTemp }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="selectItem(row)"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell error-message" colspan="5">No data matching the filter "{{ input.value }}"</td>
            </tr>
        </table>
        <div class="custom-pagination-wrap">
            <mat-paginator #paginator [pageSize]="'5'" [length]="totalSize"></mat-paginator>
        </div>
    </div>
</div>

<div
    class="gasket-template"
    *ngIf="(materialAlias && materialAlias?.materialType?.materialType == 68) || (materialAlias && materialAlias.materialTypeId == 68)"
>
    <div class="modal-header">
        <h4 style="align-items: flex-start">
            <!-- Select Gasket -->
            <ng-container *transloco="let t; read: 'STANDARD_FLANGE_PAGE.LABELS'"> {{ t('SELECT') }} {{ t('CALC_INPUT.GASKET') }} </ng-container>
        </h4>
        <a class="close-icon" href="javascript:void()" ngbAutofocus (click)="ngbActiveModal.close(false)" style="top: 10px"><i class="flaticon2-cross"></i></a>
    </div>
    <div class="modal-body scroll-table">
        <mat-tree [dataSource]="treedataSource" [treeControl]="treeControl" class="tree_button">
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
                <button mat-button (click)="selectedGasket(node)">{{ node.name }}</button>
            </mat-tree-node>

            <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
                <button (click)="toggleOthers(node)" mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
                    <mat-icon class="mat-icon-rtl-mirror">
                        {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                    </mat-icon>
                </button>
                {{ node.name }}
            </mat-tree-node>
        </mat-tree>
    </div>
</div>
